import { post, BaseUrl } from './api'

export const uploadEventLog = async (eventLog) => {
  return await post(`api/Audit/upload`, window._env_?.REACT_APP_API_BASE_URL, eventLog);
}